(() => {
  const HEADER_SEL = '#header-component';

  /**
   * Rewrite Horizon --submenu-height after Thrive promo/layout settles.
   * Does not run unless this Shop item is the expanded menu.
   * @param {HTMLElement} mega
   */
  const sync = (mega) => {
    const item = mega.closest('.menu-list__list-item');
    if (!item) return;

    const expanded = item.querySelector('[aria-expanded="true"]');
    if (!expanded) return;

    const submenu = item.querySelector(':scope > .menu-list__submenu') || mega.closest('.menu-list__submenu');
    const header = mega.closest(HEADER_SEL) || document.querySelector(HEADER_SEL);
    if (!submenu || !header) return;

    const submenuHeight = submenu.offsetHeight;
    if (submenuHeight <= 0) return;

    const topRow = header.querySelector('.header__row--top');
    let headerVisible = topRow ? topRow.offsetHeight : header.offsetHeight;
    if (header.hasAttribute('data-submenu-overlap-bottom-row') && topRow) {
      headerVisible = topRow.offsetHeight;
    }

    header.style.setProperty('--submenu-height', `${submenuHeight}px`);
    header.style.setProperty('--full-open-header-height', `${submenuHeight + headerVisible}px`);
  };

  const run = (mega) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => sync(mega));
    });
  };

  const bind = (mega) => {
    if (!(mega instanceof HTMLElement) || mega.dataset.thrMegaBound === 'true') return;
    mega.dataset.thrMegaBound = 'true';

    const schedule = () => run(mega);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(schedule).observe(mega);
    }

    mega.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', schedule, { once: true });
    });

    const item = mega.closest('.menu-list__list-item');
    if (item) {
      item.addEventListener('pointerenter', schedule);
      item.addEventListener('focusin', schedule);
      const link = item.querySelector('[ref="menuitem"]');
      if (link && typeof MutationObserver !== 'undefined') {
        new MutationObserver(schedule).observe(link, {
          attributes: true,
          attributeFilter: ['aria-expanded'],
        });
      }
    }

    schedule();
    [80, 200, 400].forEach((ms) => setTimeout(schedule, ms));
  };

  const init = () => {
    document.querySelectorAll('.thr-mega--desktop').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
